module.exports = __webpack_public_path__ + "img/running.be5030ca.webp";